
<div class="dashboard-content-sec ">
    <div class="loader" *ngIf="showloader">
        <img src="assets/images/loader.gif" alt="">
    </div>

    <form (ngSubmit)="saveContent()" [formGroup]="form">
        <div class="row form-section">
            <div class="col">
                <div class="card mb-0">
                    <app-breadcrumb [crumbList] = "crumbList"></app-breadcrumb>
                    <div class="card-title">
                        <h5 class="fa fa-building">
                          {{ this.title }}
                        </h5>

                        <div class="float-right">
                            <button type="submit" class="btn btn-default align-items-end" tabindex="100">Save</button>
                        </div>
                    </div>

                    <div class="card-form" class="collapse show">

                        <div *ngIf="submitted && this.form.invalid" class="invalid-feedback">
                            <span >Please review for the form for invalid fields</span>
                        </div>

                        <div *ngIf="this.successful_result"
                            class="alert alert-success" role="alert">
                            Successfully saved record
                        </div>
                        <div *ngIf="this.error_result" class="alert alert-danger" role="alert">
                            Unable to save record. Error occurred.
                        </div>

                        <div class="form-row" >
                            <label class='col-sm-2'>Type</label>
                            <div class='form-group col-sm-2'>
                                <select name="Type" class="form-control" formControlName="Type" tabindex="2">
                                    <option value="{{con.type}}" 
                                            *ngFor="let con of content_type">{{con.value}}
                                    </option>

                                </select>

                                <div *ngIf="TypeCtrl.invalid && (TypeCtrl.dirty || TypeCtrl.touched)"
                                    class="invalid-feedback">
                                    <div>
                                        <span>Type is required.</span>
                                    </div>
                                </div>        
                            </div>
                        </div>
                        <div class="form-row" *ngIf="form.value.Type === 1 || form.value.Type === '1'">
                            <label class='col-sm-2'>Style</label>
                            <div class='form-group col-sm-2'>
                                <select name="Style" class="form-control" formControlName="Style" tabindex="2">
                                    <option value="{{con.type}}" 
                                            *ngFor="let con of style_type">{{con.value}}
                                    </option>

                                </select>
                            </div>
                        </div>

                        <div class="form-row" *ngIf="form.value.Style === 2 || form.value.Style === '2' ||
                                                     form.value.Style === 3 || form.value.Style === '3'">
                            <label class='col-sm-2'>Link</label>
                            <div class='form-group col-sm-4'>
                                <input type="text" class="form-control"
                                       formControlName="Link" name="Link">
                            </div>
                        </div>

                        <div class="form-row" >
                            <label class='col-sm-2'>Title</label>
                            <div class='form-group col-sm-2'>
                                <input type="text" class="form-control"
                                       formControlName="Title" name="Title">

                                <div *ngIf="TitleCtrl.invalid && (TitleCtrl.dirty || TitleCtrl.touched)"
                                    class="invalid-feedback">
                                    <div>
                                        <span>Title is required.</span>
                                    </div>
                                </div>        
                            </div>
                        </div>

                        <div class="form-row" >
                            <label class='col-sm-2'>Effective Date</label>
                            <div class='col-sm-2 mb-3'>
                                <div class="input-group">
                                    <input class="form-control" placeholder="yyyy-mm-dd"
                                        name="EffDate" id="EffDate" 
                                        formControlName="EffDate"
                                        data-container="body"
                                        ngbDatepicker #d="ngbDatepicker"
                                        style="width: 200px ">
                                    <div class="input-group-append">
                                        <button class="btn btn-outline-secondary calendar fa fa-calendar" 
                                            (click)="d.toggle()" type="button"></button>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="EffDateCtrl.invalid && (EffDateCtrl.dirty || EffDateCtrl.touched)"
                                class="invalid-feedback">
                                <div>
                                    <span>Date is required.</span>
                                </div>
                            </div>        
                        </div>
                          

                        <div class="form-row">
                            <label class="col-sm-2">Content</label>
                            <div class="form-group col-sm-10">
                                <div id="body" [froalaEditor]="options" [(froalaModel)]="bodyContent"></div>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </div>
    </form>

</div>


